import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import { ConfirmBold } from '../../icons';
import TextLabel from '../textLabel/textLabel';
var PromotionalList = /*#__PURE__*/function (_React$Component) {
  function PromotionalList() {
    _classCallCheck(this, PromotionalList);
    return _callSuper(this, PromotionalList, arguments);
  }
  _inherits(PromotionalList, _React$Component);
  return _createClass(PromotionalList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dataHook = _this$props.dataHook,
        automationId = _this$props.automationId,
        items = _this$props.items,
        symbol = _this$props.symbol,
        shouldTranslate = _this$props.shouldTranslate;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        "data-aid": automationId,
        className: "control-promotional-list"
      }, items.map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          className: "promotional-list-item",
          key: item
        }, symbol, /*#__PURE__*/React.createElement(TextLabel, {
          value: item,
          type: "T05",
          shouldTranslate: shouldTranslate,
          enableEllipsis: false
        }));
      }));
    }
  }]);
}(React.Component);
PromotionalList.displayName = 'PromotionalList';
PromotionalList.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** A list of promotional list items */
  items: PropTypes.arrayOf(PropTypes.string),
  /** A prefix symbol to be displayed before each list item */
  symbol: PropTypes.element
};
PromotionalList.defaultProps = {
  items: [],
  symbol: /*#__PURE__*/React.createElement(ConfirmBold, {
    color: "success"
  })
};
export default compose(PromotionalList);